import { SquareImageComponent } from './SquareImageComponent.styles';

export default SquareImageComponent;
